import { Stack } from '@vtex/admin-ui'
import { FormState } from '@vtex/admin-ui-form'
import { SEARCH_TERM_PAGE_SIZE, useCategories } from 'hooks'
import { useMemo, useState } from 'react'
import { useIntl } from 'react-intl'
import { LIMITS } from 'shared'
import { DefaultProps } from 'typings'
import { IconBranch } from '../../../../icons'
import { MultiSelect } from '../../../MultiSelect'
import { searchItems } from '../../../utils'
import { DownloadButton } from '../DownloadButton'
import { ImportButton } from '../ImportButton'
import { SelectorHeader } from '../SelectorHeader'
import messages from './messages'

interface CategoriesSelectorProps {
  name: string
  state?: FormState
  loading?: boolean
  placeholder?: string
}

function Header(props: DefaultProps) {
  const { children } = props

  const { $t } = useIntl()

  return (
    <SelectorHeader label={$t(messages.label)} Icon={IconBranch}>
      {children}
    </SelectorHeader>
  )
}

function Selector(props: CategoriesSelectorProps) {
  const { name, state, placeholder, loading } = props

  const { $t } = useIntl()

  const [searchTerm, setSearchTerm] = useState('')

  const { data: categories, isLoading } = useCategories()

  const MAX_OPTIONS = searchTerm ? SEARCH_TERM_PAGE_SIZE : 10

  const options = useMemo(
    () => searchItems(categories, searchTerm).slice(0, MAX_OPTIONS),
    [categories, searchTerm, MAX_OPTIONS]
  )

  return (
    <MultiSelect
      name={name}
      options={options}
      label={placeholder ?? $t(messages.placeholder)}
      loading={loading}
      loadingOptions={isLoading}
      onSearch={setSearchTerm}
      state={state}
      maxEntries={LIMITS.MAX_COLLECTIONS}
    />
  )
}

export function CategoriesSelector(props: DefaultProps) {
  return (
    <Stack space="$space-2" fluid>
      {props.children}
    </Stack>
  )
}

CategoriesSelector.Header = Header
CategoriesSelector.Download = DownloadButton
CategoriesSelector.Upload = ImportButton
CategoriesSelector.Selector = Selector
